export const getOS = () => {
  if (typeof window === 'undefined') return 'Other';

  const userAgent = window.navigator.userAgent;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS';
  }

  return 'Other';
};
